import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { DataTableDirective } from 'angular-datatables';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TourService } from 'ngx-tour-md-menu';
import { environment } from '../../shared/config/app-config';
import { CallService, FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { Puser, User } from '../../shared/models';
//import {MyserviceService} from '../../myservice.service'
import { DatePipe, Location } from '@angular/common';
import { ElementRef, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventTargetInterruptSource, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { DxDataGridComponent } from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import CheckBox from 'devextreme/ui/check_box';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { ToastrService } from 'ngx-toastr';
import { ISubscription, Subscription } from "rxjs/Subscription";
import { SessiontempComponent } from '../../sessiontemp/sessiontemp.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mytodo',
  templateUrl: './mytodo.component.html',
  styleUrls: ['./mytodo.component.css']
})
export class MytodoComponent extends FormSessionCanDeactivate {
  careList1: any;
  modalRef1: BsModalRef;
  dataSource: ArrayStore;
  tempVar1: boolean; tempVar2: boolean; tempVar3: boolean; tempVar4: boolean;
  setmask: any;
  maxda: boolean = false;
  maxdate: boolean = false;
  pacEventName: any;
  paclist: any;
  paclist1: any;
  setnewdate: any;
  showinva: boolean;
  showloder: boolean;
  showinvaild54: boolean = false;
  hidecompleted: boolean = true;
  phoneset: string;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  getTotalPageCount() {
    return this.userService.translateText('hospital_portal.mytodos.pagination.label');
  }
  tooltipnew: any;
  i: number = 0;
  showinvaild: boolean;

  showinvaild1: boolean;
  traccount: any;
  public objs: any = {};
  public fliterdsate: any = {
    "startdate": '',
    "enddate": '',
  };
  dtdownloadOptions: {};
  dropdownPSettings: {};
  dropdownPacSettings: {};
  dropdownSSettings: {};
  surg: any;
  prod: any;
  hosp: any;
  downloadcare: boolean;
  down_care: {};
  temp: boolean;
  tempvar: boolean;
  timealert: any = environment.timelimit;
  tractionlist: any;
  hospid: any;
  suglist: any;
  serviceline: any;
  // userkey: any;
  // menu: any;
  oneAtATime: boolean = true;
  newreq: boolean = true;
  Download: boolean = false;
  open: boolean;
  modalRef: BsModalRef;
  public download_care: any = environment.downloadcare;
  cloudeImageURL: string = environment.cloudeImageURL;
  public apiurl: any = environment.api_url;
  public idletime: any = environment.idletime;
  public setidletime: any = environment.timeset;
  temp_var: any;
  mytodo: any;
  user: any;
  todoo = [];
  todo1 = [];
  todo2 = [];
  todo3 = [];
  change: boolean = true;
  Name = "All To-do's";
  Name1 = "All To-do's";
  // datatableElement: DataTableDirective;
  datatableElement: any;
  generate = 1;
  track = 6;
  follow = 4;
  symtom = 3;
  PUser: Puser;
  //dtOptions:any={};
  downloaddata: any = {
    pacEventName: ''
  }
  dtOptions: any = {};
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  date = new Date()
  setdate = new Date(this.date.setDate(this.date.getDate() + 1))
  resp: any;
  public dateformat = environment.dateFormat;
  public dateform = environment.dateForm;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  CurrentUser: User;
  dateFormat = {
    date: {
      pipe: this.dateform
    }
  };

  subscription: ISubscription;
  popout: boolean = false;
  filterValue: any;
  alltodoFilter: boolean = false;
  gcpTodoFilter: boolean = false;
  completedTodoFilter: boolean = false;
  gcpCompletedFilter: boolean = false;
  thdFilter: boolean = false;
  thdCompletedFilted: boolean = false;
  followUpFilter: boolean = false;
  followUpCompletedFitler: boolean = false;
  vnsFilter: boolean = false;
  vnsCompletedFilter: boolean = false;
  bundleStatus: boolean;
  dynamicReassignTodo: boolean;
  exportTooltip = 'Export All Data';
  symtomSubscription: Subscription;
  gcpSubscription: Subscription;
  todoSubscription: Subscription;
  followSubscription: Subscription;
  userSubscribe: Subscription;
  constructor(
    private zone: NgZone,
    private toast: ToastrService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
    private patientservice: PatientService,
    private userService: UserService,
    public tourService: TourService,
    private dialog: MatDialog,
    private element: ElementRef,
    private idle: Idle,
    private _location: Location,
    private keepalive: Keepalive,
    private localeService: BsLocaleService,
    private callService: CallService,
    private Datepipe: DatePipe,
    private translate: TranslateService
  ) {
    super();
    this.translate.setDefaultLang(userService.defaultLang);
    this.filterValue = []
    if (localStorage.getItem("alltodoFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("alltodoFilter")));
    }

    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    this.subscription = callService.mytodocomponentMethodCalled$.subscribe(
      () => {
        this.temp_var = false;
        this.ngOnInit()
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
      }
    );
    this.exportTooltip = this.userService.translateText('hospital_portal.mytodos.export_all_data.tooltip');
  }

  ngOnDestroy() {
    //alert("Destroy Calling Here");
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.popout) {
      this.modalRef.hide();
    }

    try {
      this.symtomSubscription?.unsubscribe();
      this.gcpSubscription?.unsubscribe();
      this.todoSubscription?.unsubscribe();
      this.followSubscription?.unsubscribe();
      this.userSubscribe?.unsubscribe();
    } catch(err) {
      
    }
  }


  //  this.zone.run()
  public imageURL: string = environment.cloudeImageURL;

  ngOnInit() {
    this.generate = 1;
    this.track = 6;
    this.follow = 4;
    this.symtom = 3;
    this.gcpName = '';
    this.thdName = '';
    this.followName = '';
    this.symtomName = '';
    this.todoo = [];
    this.todo1 = [];
    this.todo2 = [];
    this.todo3 = [];
    this.tempVar1 = false;
    this.tempVar2 = false;
    this.tempVar3 = false;
    this.tempVar4 = false;
    this.Name = this.userService.translateText('hospital_portal.mytodos.alltodos.label');
    this.Name1 = this.userService.translateText('hospital_portal.mytodos.alltodos.label');
    this.hidecompleted = true;
    this.alltodoFilter = true;
    this.select = false
    this.maintainReassign = window.localStorage['maintainReassign'] == "true" ? window.localStorage['maintainReassign'] : false;
    if (this.maintainReassign) {
      this.careList1 = JSON.parse(window.localStorage['maintainCareList'])
      this.dynamicdropdown = true;
    }



    // this.selectedItems = [
    //   { item_id: 3, item_text: 'Pune' },
    //   { item_id: 4, item_text: 'Navsari' }
    // ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'hospitalId',
      textField: 'HospitalName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };

    this.dropdownSSettings = {
      singleSelection: false,
      idField: 'UserAccountId',
      textField: 'SurgeonName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.dropdownPSettings = {
      singleSelection: false,
      idField: 'ServicelineLabel',
      textField: 'ServicelineLabelDisplayName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.dropdownPacSettings = {
      singleSelection: true,
      idField: 'dischargeTypeName',
      textField: 'dischargeTypeDisplayName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.userSubscribe = this.userService.currentUser.subscribe(
      (userData) => {

        this.CurrentUser = userData;
        this.CurrentUser.status = false;
        if (this.CurrentUser.item) {
          this.bundleStatus = this.CurrentUser.item.bundleStatus
          this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0');
          if (this.CurrentUser.item.dateFormat)
            if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
              this.dateformat = environment.dateFormat;
              this.dateform = environment.dateForm;

            } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
              this.dateformat = 'DD/MM/YYYY'
              this.dateform = 'dd/MM/yyyy'
              this.dateFormat = {
                date: {
                  pipe: this.dateform
                }
              };
            }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.CurrentUser.item) {
            if (this.CurrentUser.item.hostModel == "CLOUD")
              this.imageURL = environment.cloudeImageURL;
            else
              this.imageURL = environment.vmImageURL;
            if (this.CurrentUser.item.appRoles != 'PATIENT')
              this.getmytodolength()
            this.patientservice.getTodoMapByClient(this.CurrentUser.item.userAccountKey, this.CurrentUser.item.userAccountId).subscribe(
              data => {
                if (data) {
                  let index = _.findIndex(data, (o: any): any => {
                    return o.seqNo == 1
                  })
                  if (index != -1) {
                    this.generate = data[index].todoCategoryId
                    this.gcpName = data[index].todoTitle
                  }
                  let index2 = _.findIndex(data, (o: any): any => {
                    return o.seqNo == 2
                  })
                  if (index2 != -1) {
                    this.track = data[index2].todoCategoryId
                    this.thdName = data[index2].todoTitle
                  }
                  let index3 = _.findIndex(data, (o: any): any => {
                    return o.seqNo == 3
                  })
                  if (index3 != -1) {
                    this.follow = data[index3].todoCategoryId
                    this.followName = data[index3].todoTitle
                  }
                  let index4 = _.findIndex(data, (o: any): any => {
                    return o.seqNo == 4
                  })
                  if (index4 != -1) {
                    this.symtom = data[index4].todoCategoryId
                    this.symtomName = data[index4].todoTitle
                  }
                }

                this.showloder = true
                this.dtOptions = {
                  // Configure the pagelength

                  pageLength: 10,
                  lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                  dom: 'Blfrtip',
                  columnDefs: [{ type: "date", targets: [5] }, { type: "date", targets: [6] }, { type: "date", targets: [9] }],
                  buttons: [
                    {
                      extend: 'excelHtml5',
                      exportOptions: {
                        columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
                      },
                      text: 'Download Excel',
                      className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
                      title: this.getTitle()
                    },
                    {
                      extend: 'pdfHtml5',
                      exportOptions: {
                        columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
                      },
                      orientation: 'landscape',
                      text: 'Download PDF',
                      className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5 ',
                      title: this.getTitle()
                    },

                  ]
                };
                this.dtdownloadOptions = {
                  // Configure the pagelength
                  pageLength: 5,
                  lengthMenu: [[5, 10, 25, -1], [5, 10, 25, "All"]],
                  order: [[0, "desc"]],
                  columnDefs: [{ type: "date", targets: [0] }, { orderable: false, targets: [2] }],


                };

                this.userService
                  .getsession()
                  .subscribe(
                    data => {
                      this.user = data;
                      if (this.user.item.DeidFlag)
                        this.startTour();

                    }

                  );
                this.countdownload()
                this.caredownload()

                this.userService
                  .gethosp(this.CurrentUser.item.userAccountKey, this.CurrentUser.item.userAccountId)
                  .subscribe(
                    data => {
                      //  ////console.log(data)
                      this.dropdownList = data;
                      ////console.log(this.dropdownList)
                    }
                  );

                this.patientservice
                  .getSurgeonlist(this.CurrentUser.item.userAccountId)
                  .subscribe(
                    data => {
                      ////console.log(data)
                      //  this.dropdownList = data;
                      this.suglist = data
                    }
                  );
                this.userService
                  .getDisList(this.CurrentUser.item.userAccountKey)
                  .subscribe(
                    data => {
                      ////console.log(data)
                      this.paclist = data;
                      this.paclist.forEach(element => {
                        element.typeName = element.dischargeTypeName
                      });
                    }
                  );



                this.patientservice
                  .getBodyLocation(this.CurrentUser.item.userAccountKey)
                  .subscribe(
                    data => {

                      this.serviceline = data.ServicelineLabel;
                      this.serviceline = _.remove(this.serviceline, (o: any): any => {
                        return o.ServicelineLabel.toLowerCase() != "other."
                      })
                    }


                  );
                if (this.gcpName) {
                  this.gcpSubscription = this.patientservice.gettodolist(this.generate, this.CurrentUser.item.userAccountId).subscribe(
                    data => {
                      this.todoo = data;
                      this.tempVar1 = true
                      ////console.log("todo", this.todoo);

                      /*** Today Changes start here ***/
                      //   if(this.patientservice.userFilter){
                      //    this.todoo = this.todoo.filter(i =>
                      //       i.createdBy==parseInt(this.CurrentUser.item.selectCNUserId));
                      //  }

                    }
                  );
                }
                if (this.thdName) {
                  this.todoSubscription = this.patientservice.gettodolist(this.track, this.CurrentUser.item.userAccountId).subscribe(
                    data => {
                      this.todo1 = data;
                      this.tempVar2 = true
                      ////console.log("Todo1", this.todo1)
                      /*** Today Changes start here ***/
                      // if(this.patientservice.userFilter){
                      //  this.todo1 = this.todo1.filter(i =>
                      //    i.createdBy==parseInt(this.CurrentUser.item.selectCNUserId));
                      //  }

                    }
                  );
                }
                if (this.followName) {
                  this.followSubscription =  this.patientservice.gettodolist(this.follow, this.CurrentUser.item.userAccountId).subscribe(
                    data => {
                      this.todo2 = data;
                      this.tempVar3 = true
                      ////console.log("Followup count",this.todo2 )
                      /*** Today Changes start here ***/
                      // if(this.patientservice.userFilter){
                      //  this.todo2 = this.todo2.filter(i =>
                      //    i.createdBy==parseInt(this.CurrentUser.item.selectCNUserId));
                      //  }
                    }
                  );
                }
                if (this.symtomName) {
                  this.symtomSubscription = this.patientservice.gettodolist(this.symtom, this.CurrentUser.item.userAccountId).subscribe(
                    data => {
                      this.todo3 = data;
                      this.tempVar4 = true
                      ////console.log("Todo3", this.todo3)
                      /*** Today Changes start here ***/
                      // if(this.patientservice.userFilter){
                      //  this.todo3 = this.todo3.filter(i =>
                      //    i.createdBy==parseInt(this.CurrentUser.item.selectCNUserId));
                      //  }
                    }
                  );
                  this.showloder = false
                }

              })
          }
          else {
            this.imageURL = environment.vmImageURL;
          }
        }
        // this.userkey = userData.item.userAccountKey;
        if (window.localStorage['startdate'] && window.localStorage['enddate']) {
          this.fliterdsate.startdate = new Date(window.localStorage['startdate'])
          this.fliterdsate.enddate = new Date(window.localStorage['enddate'])
          this.alllist(this.fliterdsate)
        }
        else {
          this.fliterdsate = {}
        }

      }
    )

    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    this.mytodo = [];
    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": startdate,
      "endDateRange": enddate,
      "pracOrHsp": '',
      "todoViewMode": '',
      "loginHspOrPracId": '',
      "todoCategoryId": '',
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }

    this.patientservice
      .todolistbyrange(obj)
      .subscribe(
        data => {

          // alert("AlltoDo")
          this.temp_var = true;
          this.mytodo = data;
          this.showloder = false
          for (var i = 0; i < this.mytodo.length; i++) {
            if (this.mytodo[i].payorType == 2 && this.mytodo[i].bpci && this.mytodo[i].cjr != 'Y') {
              this.mytodo[i].group = 'BPCI-A' + '-' + this.mytodo[i].bpci;
            }
            else if (this.mytodo[i].cjr == 'Y' && this.mytodo[i].payorType == 2) {
              this.mytodo[i].group = 'CJR';
            }
            else if (this.mytodo[i].payorType == 1 && this.CurrentUser?.item?.commercialType && this.mytodo[i].cjr == 'N') {
              this.mytodo[i].group = 'Commercial';
            }
            else {
              this.mytodo[i].group = '';
            }
            if (this.mytodo[i].fracture == 'Y') {
              this.mytodo[i].fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
            }
            if (this.mytodo[i].mako == 'Yes') {
              this.mytodo[i].mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
            }
            if (this.mytodo[i].todoTypeName) {
              this.mytodo[i].todoType = this.mytodo[i].todoTypeName
              if (this.mytodo[i].todoType.includes("Custom To-Do")) {
                this.mytodo[i].todoType = 'Custom To-Do'
              }
            }
            // if (this.mytodo[i].pswIsActive) {
            //   this.mytodo[i].patientStatus = "Deactivate"
            // }
            this.mytodo[i].ID = i
          }

          if (this.mytodo[0] && this.mytodo[0].error) {

            if (this.i == 0) {
              this.toast.error(data[0].error, '', {
                timeOut: this.timealert
              });
            }

          }
          /*** Today Changes start here ***/
          //  if(this.patientservice.userFilter){
          //  this.mytodo = this.mytodo.filter(i =>
          //    i.createdBy==parseInt(this.CurrentUser.item.selectCNUserId));

          //  }

          if (window.localStorage['setBugetFilter'] == 1) {
            if (window.localStorage['completed'] == 1) {
              this.generatecompleted()
            }
            else {
              this.changeName();
            }
          }
          else if (window.localStorage['setBugetFilter'] == 0) {
            if (window.localStorage['completed'] == 1) {
              this.completed()
            }
          }
          else if (window.localStorage['setBugetFilter'] == 2) {
            if (window.localStorage['completed'] == 1) {
              this.trackcompleted()
            }
            else {
              this.changeName1();
            }
          }
          else if (window.localStorage['setBugetFilter'] == 3) {
            if (window.localStorage['completed'] == 1) {
              this.followcompleted()
            }
            else {
              this.changeName2();
            }
          }
          else if (window.localStorage['setBugetFilter'] == 4) {
            if (window.localStorage['completed'] == 1) {
              this.viewcompleted()
            }
            else {
              this.changeName3();
            }
          }
          this.dataSource = new ArrayStore({
            key: "ID",
            data: this.mytodo
          });
          this.patientservice.myTodoCount = this.mytodo.length;
        }
      );
    // if(this.mytodo)
    // this.showloder  = false

    //this.


    //Getting Reassign overLab Details
    if (this.CurrentUser.item) {
      this.getOverlabReassignList();
      // if (!this.dynamicdropdown){
      //   this.getReassignStaticTodoCN(this.CurrentUser.item.userAccountId,false);
      // }
    }
  }

  multiSOSStatus: boolean;
  getOverlabReassignList() {
    if (this.CurrentUser.item.userGroupId == 9 || this.CurrentUser.item.userGroupId == 17
      || this.CurrentUser.item.userGroupId == 32 || this.CurrentUser.item.userGroupId == 33) {
      if (this.CurrentUser.item.userGroupId == 9 || this.CurrentUser.item.userGroupId == 33) {
        this.patientservice.fetchTodoRAHospitalOverlapSurgeons(this.CurrentUser.item.userAccountId, 0)
          .subscribe(data => {
            this.selectedData = data;
            if (this.selectedData[0].todoRAOverlapMultiPracticeBeanList && this.selectedData[0].todoRAOverlapMultiPracticeBeanList.length >= 1) {
              this.dynamicReassignTodo = true;
            } else {
              this.getReassignStaticTodoCN(this.CurrentUser.item.userAccountId, false);
            }
          })

      }
      else if (this.CurrentUser.item.userGroupId == 17 || this.CurrentUser.item.userGroupId == 32) {
        this.patientservice.fetchTodoRAPracticeOverlapHospitals(this.CurrentUser.item.userAccountId, 0)
          .subscribe(data => {
            this.selectedData = data;
            if (this.selectedData[0].reAssignHospitalBeanList && this.selectedData[0].reAssignHospitalBeanList.length >= 1) {
              this.dynamicReassignTodo = true;
            }
            else {
              this.getReassignStaticTodoCN(this.CurrentUser.item.userAccountId, false);
            }
          })
      }


    }

    // if (this.CurrentUser.item.userGroupId == 33) {
    //   this.patientservice.fetchTodoRAHospitalHNSurgeons(this.CurrentUser.item.userAccountId)
    //     .subscribe(data => {
    //       this.selectedData = data;
    //       console.log("33", this.selectedData)
    //     })

    // }
    // else if (this.CurrentUser.item.userGroupId == 32) {
    //   this.patientservice.fetchTodoRAPracticePCHospitals(this.CurrentUser.item.userAccountId)
    //     .subscribe(data => {
    //       this.selectedData = data;
    //       console.log("32", this.selectedData)
    //     })
    // }
  }
  filterhospitalData: Array<any>;
  filterSurgeonData: Array<any> = [];
  filterValues: Array<any> = [];
  filterSurgeonValue: any;
  filterHospitalValue: any;
  filterhospitalId: any;
  filterSurgeonId: any;
  selectedhspUnderSurgeonId: any = '0';
  raHospitalIsOverlap: boolean = false;
  raSurgeonIsOverlap: boolean = false;
  filteroverlapNonoverlap() {
    var selectHos = ''
    var selectHosId = 0
    if (this.CurrentUser.item.userGroupId == 17 || this.CurrentUser.item.userGroupId == 32) {
      this.filterhospitalData = [];
      this.selectedData.forEach(element => {
        element.reAssignHospitalBeanList.forEach(data => {
          if (data.selected) {
            this.filterhospitalData.push(data.name);
            this.raHospitalIsOverlap = data.overlap ? data.overlap : false;
            this.filterhospitalId = !this.filterhospitalId ? data.hospitalId : this.filterhospitalId + ',' + data.hospitalId
            this.maintainReassign = true;
            window.localStorage['maintainReassign'] = true;
            selectHosId = data.hospitalId ? data.hospitalId : 0
            // localStorage.setItem("alltodoFilter", JSON.stringify(this.filterValue));
          }
          if (data.multiStatus) {
            data.todoRAHospitalMultiSOSBean.forEach(item => {
              if (item.selected) {
                this.filterhospitalData.push(item.name);

                this.raHospitalIsOverlap = item.overlap ? item.overlap : false;
                this.filterhospitalId = !this.filterhospitalId ? item.hospitalId : this.filterhospitalId + ',' + data.hospitalId
                this.maintainReassign = true;
                selectHos = data.overlappedClientName ? data.overlappedClientName : ''
                //selectHosId = item.hospitalId ? item.hospitalId : 0
                window.localStorage['maintainReassign'] = true;

              }
            });
          }

        });
      });
      if (this.filterhospitalData.length == 1) {
        this.filterhospitalData.push(" ");
      }

      // console.log("this.filterhospitalData", this.filterhospitalData)


      //this.ngAfterContentChecked();
      this.modalRef1.hide();
      this.getReassignTodoCN(this.CurrentUser.item.userAccountId, false, selectHos, selectHosId);
      this.getCountDetailsRaTodoOverLapFilter();

      //this.dataGrid.instance.filter([[arrayTest]]);
    }
    else if (this.CurrentUser.item.userGroupId == 9 || this.CurrentUser.item.userGroupId == 33) {
      this.filterSurgeonData = [];
      this.selectedData.forEach(element => {

        element.todoRAOverlapMultiPracticeBeanList.forEach(data => {
          data.reAssignSurgeonBeanList.forEach(it => {
            if (it.selected) {
              this.filterSurgeonData.push(it.surgeonName);
              this.selectedhspUnderSurgeonId = it.practiceId ? it.practiceId : 0;
              this.raSurgeonIsOverlap = it.overlap ? it.overlap : false;
              this.filterSurgeonId = !this.filterSurgeonId ? it.surgeonId : this.filterSurgeonId + ',' + it.surgeonId;
              selectHos = data.overlappedClientName ? data.overlappedClientName : ''
              selectHosId = data.overlappedClientId ? data.overlappedClientId : 0
              this.maintainReassign = true;
              window.localStorage['maintainReassign'] = true;
            }
          });
        });

        if (this.filterSurgeonData.length == 1) {
          this.filterSurgeonData.push(" ");
        }

        // console.log("this.filterSurgeonData", this.filterSurgeonData)

        //  this.applyFilter(this.filterType , this.filterSurgeonData)


        this.modalRef1.hide();
        this.getReassignTodoCN(this.CurrentUser.item.userAccountId, false, selectHos, selectHosId);
        this.getCountDetailsRaTodoOverLapFilter();
      });
      // this.ngAfterContentChecked();
    }
  }

  getCountDetailsRaTodoOverLapFilter() {
    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N',
      "endDateRange": window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N',
      "pracOrHsp": '',
      "todoViewMode": "",
      "loginHspOrPracId": '',
      "todoCategoryId": '',
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }

    this.patientservice.getCountDetailsRaTodoOverLapFilter(obj)
      .subscribe(
        data => {
          this.CurrentUser.item.mytodolength = data.todoCount
          this.CurrentUser.item.msgcount = data.messageCount;
        }
      );


  }
  // Get reassign todo CN List
  reassignCNList: any;
  dynamicdropdown: boolean = false;

  getReassignTodoCN(userAccountId, overLab, selectHos, selectHosId) {
    //this.careList = [];
    if (this.CurrentUser.item.userGroupId == 9 || this.CurrentUser.item.userGroupId == 33) {
      this.getReassignTodoCNforSurgeon(userAccountId, this.raSurgeonIsOverlap, this.selectedhspUnderSurgeonId, selectHosId);
    }
    else if (this.CurrentUser.item.userGroupId == 17 || this.CurrentUser.item.userGroupId == 32) {
      this.getReassignTodoCNforHospital(userAccountId, this.raHospitalIsOverlap, selectHosId)
    }
  }

  ngAfterContentChecked() {
    if (this.filterSurgeonData && this.filterSurgeonData.length == 1) {
      this.filterSurgeonData.push(" ");
    }

    if (this.filterhospitalData && this.filterhospitalData.length == 1) {
      this.filterhospitalData.push(" ");
    }
  }

  filterType: string = "include";
  maintainReassign: boolean = false;
  selectedOperation: string = "contains";

  // applyFilter(filterType, filterValue) {
  //  // this.filterType = filterType;
  //   // this.filterhospitalData = this.filterhospitalData;
  //   // this.filterSurgeonData = this.filterSurgeonData;
  //  // this.filterValues = values;

  //  if(this.filterhospitalData && this.filterhospitalData.length > 1){
  //    //this.selectedOperation = "";
  //    this.filterType = 'include'
  //   this.filterhospitalData = this.filterhospitalData;
  //   }
  //   else if(this.filterSurgeonData && this.filterSurgeonData.length > 1){    
  //    //this.selectedOperation = "";
  //    this.filterType = 'include'
  //     this.filterSurgeonData = this.filterSurgeonData
  //   }

  //   if(this.filterSurgeonData && this.filterSurgeonData.length==1){
  //     //this.filterType = ''
  //     this.selectedOperation = "contains"
  //     this.filterSurgeonValue = this.filterSurgeonData[0];
  //     this.filterSurgeonData = [];
  //   }
  //   else if(this.filterhospitalData && this.filterhospitalData.length==1){

  //     this.filterType = ''
  //     this.selectedOperation = "contains"
  //     this.filterHospitalValue = this.filterhospitalData[0];
  //   }
  // }

  todoOverlap: boolean = true;
  todoOverlapboolean: boolean = false
  checkAllSelected(selectSOS, event) {
    setTimeout(() => {

      if (event) {
        let overlapSelect: any;
        let nonOverlapSelect: any;
        selectSOS.selected = true
        if (this.CurrentUser.item.userGroupId == 9 || this.CurrentUser.item.userGroupId == 33) {
          this.selectedData.forEach(element => {

            element.todoRAOverlapMultiPracticeBeanList.forEach(data => {
              if (data != selectSOS) {
                data.selected = false
                data.reAssignSurgeonBeanList.forEach(it => {
                  it.selected = false;
                });

              } else {
                data.selected = true
                data.reAssignSurgeonBeanList.forEach(it => {
                  it.selected = true;
                })
              }
            });

          });
        }

        else if (this.CurrentUser.item.userGroupId == 17 || this.CurrentUser.item.userGroupId == 32) {
          if (selectSOS.sosCategory == "Non-Overlap") {
            this.todoOverlapboolean = true
          } else {
            this.todoOverlapboolean = false
          }
          this.selectedData.forEach(element => {
            if (element != selectSOS) {
              element.selected = false
              element.reAssignHospitalBeanList.forEach(data => {
                data.selected = false;
                data.todoRAHospitalMultiSOSBean.forEach(it => {
                  it.selected = false;
                });
              });
            } else {
              element.selected = true
              element.reAssignHospitalBeanList.forEach(data => {
                data.selected = true;
                data.todoRAHospitalMultiSOSBean.forEach(it => {
                  it.selected = true;
                });
              });
            }
          });




        }
      }
    })
  }



  countdownload() {
    this.patientservice
      .gettransactionList(this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          this.traccount = data.Count;

        }
      );
  }
  checkempty(id) {
    ////console.log(id)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
    } else if (id != '' && id != null) {
      this.showinvaild = false
    }
  }

  checkempty1(id) {
    this.maxdate = false
    if (this.fliterdsate.enddate) {
      this.setnewdate = ""
      this.fliterdsate.enddate = ""
    } else {
      this.setnewdate = this.fliterdsate.startdate;
    }
    this.setnewdate = this.fliterdsate.startdate;


    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curr = this.Datepipe.transform(this.changeFormatToDate(this.setdate), 'yyyy/MM/dd');
    if (date < curr) {
      this.fliterdsate.startdate = ""
      this.maxdate = true
    }
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild1 = true
    } else if (id != '' && id != null) {
      this.showinvaild1 = false
    }



  }

  checkey1(id) {
    this.maxda = false
    let date = this.Datepipe.transform(id, 'yyyy/MM/dd');
    let curr = this.Datepipe.transform(this.changeFormatToDate(this.fliterdsate.startdate), 'yyyy/MM/dd');
    if (date < curr) {
      this.fliterdsate.enddate = ""
      this.maxda = true
    }
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinva = true
    } else if (id != '' && id != null) {
      this.showinva = false
    }
  }

  caredownload() {
    this.tempvar = false
    this.patientservice
      .transactionList(this.CurrentUser.item.userAccountId, this.CurrentUser.item.userAccountKey)
      .subscribe(
        data => {
          this.tractionlist = data;
          this.tempvar = true
          ////console.log(data)
        }
      );


  }
  idleState = 'NOT_STARTED';
  timedOut = false;
  lastPing?: Date = null;
  progressBarPopup: MatDialogRef<SessiontempComponent>;

  req() {
    this.newreq = true;
    this.Download = false;
  }
  down() {

    this.newreq = false;
    this.Download = true;
    this.caredownload()
    this.patientservice
      .puttransactionList(this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          if (data)
            this.userService.logAudit('Download Care Plan get Archive List', 0).subscribe(data => { })
          this.countdownload()
        }
      );

  }
  onItemSelect(item: any) {
    ////console.log(item);
    let ab: any = new Array<any>();
    if (item) {
      ab.push(item.hospitalId)
    }
    if (this.hosp == undefined || this.hosp == "" || this.hosp == null)
      this.hosp = ab.toString()
    else
      this.hosp = this.hosp + ',' + ab.toString()
  }
  onSItemSelect(item: any) {
    ////console.log(item);
    let ab: any = new Array<any>();
    if (item) {
      ab.push(item.UserAccountId)
    }
    if (this.surg == undefined || this.surg == "" || this.surg == null)
      this.surg = ab.toString()
    else
      this.surg = this.surg + ',' + ab.toString()
  }
  onPacItemSelect(item: any) {
    ////console.log(item);
    let ab: any = new Array<any>();
    if (item) {
      ab.push(item)
    }
    if (this.pacEventName == undefined || this.pacEventName == "" || this.pacEventName == null)
      this.pacEventName = ab.toString()
    else
      this.pacEventName = this.pacEventName + ',' + ab.toString()
  }
  onPItemSelect(item: any) {
    let ab: any = new Array<any>();
    if (item) {
      ab.push(item.ServicelineLabel)
    }
    if (this.prod == undefined || this.prod == "" || this.prod == null)
      this.prod = ab.toString()
    else
      this.prod = this.prod + ',' + ab.toString()
  }

  onItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.hosp.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item.hospitalId
      })
    }
    this.hosp = ab.toString()
  }
  onSItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.surg.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item.UserAccountId
      })

    }
    this.surg = ab.toString()

  }
  onPItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.prod.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item.ServicelineLabel
      })
    }
    this.prod = ab.toString()
  }

  onPacItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.pacEventName.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item
      })
    }
    this.pacEventName = ab.toString()
  }
  onItemDeSelectAll(items: any) {
    this.hosp = null
  }
  onSItemDeSelectAll(items: any) {
    this.surg = null
  }
  onPItemDeSelectAll(items: any) {
    this.prod = null
  }
  onPacItemDeSelectAll(items: any) {
    this.pacEventName = null
  }
  onSelectAll(items: any) {
    ////console.log(items);
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ////console.log(element.HospitalPracticeId)
        ab.push(element.hospitalId);
      });
      ////console.log(ab.toString())
      this.hosp = ab.toString();
    }
    else {
      this.hosp = null;
    }
  }
  onPSelectAll(items: any) {
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ab.push(element.ServicelineLabel);
      });
      this.prod = ab.toString();
    }
    else {
      this.prod = null;
    }
  }
  onPacSelectAll(items: any) {
    ////console.log(items);
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ////console.log(element)
        ab.push(element);

      });
      ////console.log(ab.toString())
      this.pacEventName = ab.toString();
    }
    else {
      this.pacEventName = null;
    }
  }
  onSSelectAll(items: any) {
    ////console.log(items);
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ////console.log(element.UserAccountId)
        ab.push(element.UserAccountId);

      });
      ////console.log(ab.toString())
      this.surg = ab.toString();
    }
    else {
      this.surg = null;
    }
  }
  session() {

    this.resetTimeOut();
    //alert("Session Calling");
    // sets an idle timeout of 15 minutes.
    this.idle.setIdle(this.idletime);
    // sets a timeout period of 5 minutes.

    // alert("1");
    this.idle.setTimeout(this.setidletime);
    // sets the interrupts like Keydown, scroll, mouse wheel, mouse down, and etc
    this.idle.setInterrupts([
      new EventTargetInterruptSource(
        this.element.nativeElement, 'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll')]);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'NO_LONGER_IDLE';

    });
    // alert("2");

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'NO_LONGER_IDLE';

    });

    //alert("3");

    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'TIMED_OUT';
      this.timedOut = true;
      //this.closeProgressForm();
      this.progressBarPopup.close();
      //localStorage.clear();
      window.localStorage['session'] = true;
      this.logout();
    });

    // alert("4");
    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'IDLE_START';
      this.openProgressForm(1);
    });

    // alert("5");

    this.idle.onTimeoutWarning.subscribe((countdown: any) => {

      this.sessionForm(countdown);
    });

    //  alert("6");
    this.keepalive.interval(15);

    //  alert("7");
    this.idle.watch();


    //alert("Bottom");

  }
  public openProgressForm(count: number) {

    this.progressBarPopup = this.dialog.open(SessiontempComponent, { hasBackdrop: true, disableClose: true });
    this.progressBarPopup.componentInstance.count = count;

    this.progressBarPopup.afterClosed().subscribe(result => {


      this.progressBarPopup.close();

      //  alert(result);

      if (result == 'logout' || result == undefined) {
        this.logout();

      } else {

        this.resetTimeOut();
        this.session();
      }


    });
  }
  careplan(templatecareplan: TemplateRef<any>) {
    this.modalRef = this.modalService.show(templatecareplan, { class: 'modal-lg', backdrop: "static" });
    this.popout = true;
    this.movable()
  }


  logout() {

    this.resetTimeOut();
    /* if(this.status.reports){  */
    //this.userService.logoutuser(this.CurrentUser.item.userAccountId)
    this.progressBarPopup.close();
    /* } */
    this.userService.purgeAuth();


    this.maintainReassign = false
    this.dynamicdropdown = false;
    this.filterSurgeonId = ""
    this.filterhospitalId = ""


    // setTimeout(() => {
    //   this.ngOnInit();
    // },1000)
  }

  closeProgressForm() {
    this.progressBarPopup.close();
    //this.resetTimeOut()
  }

  resetTimeOut() {
    try {
      this.idle.stop();
      this.idle.ngOnDestroy();
      this.idle.onTimeout.observers.length = 0;
      this.idle.onIdleStart.observers.length = 0;
      this.idle.onIdleEnd.observers.length = 0;
      this.idle.onTimeoutWarning.observers.length = 0;
    } catch (Exception) {

    }
    /* this.idle.onIdleStart.unsubscribe();
    this.idle.onTimeoutWarning.unsubscribe();
    this.idle.onIdleEnd.unsubscribe();
    this.idle.onTimeoutWarning.unsubscribe(); */

  }

  public sessionForm(countdown: any): any {
    this.idleState = 'IDLE_TIME_IN_PROGRESS';
    this.progressBarPopup.componentInstance.count = (Math.floor((countdown - 1) / 60) + 1);
    this.progressBarPopup.componentInstance.progressCount = this.reverseNumber(countdown);
    this.progressBarPopup.componentInstance.countMinutes = (Math.floor(countdown / 60));
    this.progressBarPopup.componentInstance.countSeconds = countdown % 60;
  }

  reverseNumber(countdown: number) {
    return (300 - (countdown - 1));
  }








  getTitle() {
    return `Mytodo List`
  }
  log(event: boolean) {
    this.open = event;
  }

  // setBugetFilter: any;
  changeName() {
    //  this.setBugetFilter = 1    
    this.dataGrid.instance.deselectAll();
    window.localStorage['setBugetFilter'] = 1;
    window.localStorage['completed'] = 0;
    this.hidecompleted = true;
    this.change = true;
    this.Name = this.gcpName;
    this.temp_var = false;
    this.mytodo = [];
    this.makeFilterFalse();
    this.gcpTodoFilter = true;
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    ////console.log("CNID", this.patientservice.CN_id)

    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": startdate,
      "endDateRange": enddate,
      "pracOrHsp": '',
      "todoViewMode": '',
      "loginHspOrPracId": '',
      "todoCategoryId": this.generate,
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }
    this.getCategory(obj);


    //this.clearFilter(event);
    this.filterValue = [];
    if (localStorage.getItem("gcpFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("gcpFilter")));
    }

  }
  getCategory(obj) {
    this.userService
      .getCategory(obj)
      .subscribe(
        data => {
          this.mytodo = [];

          this.mytodo = data;
          this.temp_var = true
          this.showloder = false;
          for (var i = 0; i < this.mytodo.length; i++) {
            // && this.mytodo[i].bpci == 'Y'
            if (this.mytodo[i].payorType == 2 && this.mytodo[i].cjr != 'Y') {
              this.mytodo[i].group = 'BPCI-A' + '-' + this.mytodo[i].bpci;
            }
            else if (this.mytodo[i].cjr == 'Y' && this.mytodo[i].payorType == 2) {
              this.mytodo[i].group = 'CJR';
            }
            else if (this.mytodo[i].payorType == 1 && this.CurrentUser?.item?.commercialType && this.mytodo[i].cjr == 'N') {
              this.mytodo[i].group = 'Commercial';
            }
            else {
              this.mytodo[i].group = '';
            }
            if (this.mytodo[i].fracture == 'Y') {
              this.mytodo[i].fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
            }
            if (this.mytodo[i].mako == 'Yes') {
              this.mytodo[i].mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
            }
            if (this.mytodo[i].todoTypeName) {
              this.mytodo[i].todoType = this.mytodo[i].todoTypeName
              if (this.mytodo[i].todoType.includes("Custom To-Do")) {
                this.mytodo[i].todoType = 'Custom To-Do'
              }
            }
            // if (this.mytodo[i].pswIsActive) {
            //   this.mytodo[i].patientStatus = "Deactivate"
            // }
            this.mytodo[i].ID = i
          }
          this.dataSource = new ArrayStore({
            key: "ID",
            data: this.mytodo
          });
        }
      );
  }
  changeName1() {
    this.dataGrid.instance.deselectAll();
    this.change = true;
    this.hidecompleted = true;
    window.localStorage['setBugetFilter'] = 2;
    window.localStorage['completed'] = 0;
    this.Name = this.thdName;
    this.temp_var = false;
    this.mytodo = [];
    this.dataSource = new ArrayStore()
    this.makeFilterFalse();
    this.thdFilter = true;
    ////console.log("CNID", this.patientservice.CN_id)
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';


    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": startdate,
      "endDateRange": enddate,
      "pracOrHsp": '',
      "todoViewMode": '',
      "loginHspOrPracId": '',
      "todoCategoryId": this.track,
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }
    this.getCategory(obj);
    this.filterValue = [];
    if (localStorage.getItem("thdFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("thdFilter")));
    }
  }
  changeName2() {
    this.dataGrid.instance.deselectAll();
    window.localStorage['setBugetFilter'] = 3;
    window.localStorage['completed'] = 0;
    this.change = true;
    this.hidecompleted = true;
    this.Name = this.followName;
    this.temp_var = false;
    this.mytodo = [];
    this.makeFilterFalse();
    this.followUpFilter = true;
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    ////console.log("CNID", this.patientservice.CN_id)


    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": startdate,
      "endDateRange": enddate,
      "pracOrHsp": '',
      "todoViewMode": '',
      "loginHspOrPracId": '',
      "todoCategoryId": this.follow,
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }


    this.getCategory(obj);
    this.filterValue = [];
    if (localStorage.getItem("followupFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("followupFilter")));
    }

  }
  changeName3() {
    this.dataGrid.instance.deselectAll();
    window.localStorage['setBugetFilter'] = 4;
    window.localStorage['completed'] = 0;
    this.change = true;
    this.hidecompleted = true;
    this.Name = this.symtomName;
    this.temp_var = false;
    this.mytodo = [];
    this.makeFilterFalse();
    this.vnsFilter = true;
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    ////console.log("CNID", this.patientservice.CN_id)


    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": startdate,
      "endDateRange": enddate,
      "pracOrHsp": '',
      "todoViewMode": '',
      "loginHspOrPracId": '',
      "todoCategoryId": this.symtom,
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }


    this.getCategory(obj);
    this.filterValue = [];
    if (localStorage.getItem("vnsFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("vnsFilter")));
    }
  }

  completed() {
    this.dataGrid.instance.deselectAll();
    window.localStorage['completed'] = 1;
    window.localStorage['setBugetFilter'] = 0;
    this.change = false;
    this.hidecompleted = false
    this.Name = this.userService.translateText('hospital_portal.mytodos.completedtodos.label');
    this.temp_var = false;
    this.makeFilterFalse();
    this.completedTodoFilter = true;
    this.mytodo = [];
    this.dataSource = new ArrayStore()
    this.patientservice.gettodocompleted(this.CurrentUser.item.userAccountId).subscribe(
      data => {
        this.mytodo = data;
        this.temp_var = true;
        this.showloder = false;
        for (var i = 0; i < this.mytodo.length; i++) {
          if (this.mytodo[i].payorType == 2 && this.mytodo[i].bpci && this.mytodo[i].cjr != 'Y') {
            this.mytodo[i].group = 'BPCI-A' + '-' + this.mytodo[i].bpci;
          }
          else if (this.mytodo[i].cjr == 'Y' && this.mytodo[i].payorType == 2) {
            this.mytodo[i].group = 'CJR';
          } else if (this.mytodo[i].payorType == 1 && this.CurrentUser?.item?.commercialType && this.mytodo[i].cjr == 'N') {
            this.mytodo[i].group = 'Commercial';
          }
          else {
            this.mytodo[i].group = '';
          }
          if (this.mytodo[i].fracture == 'Y') {
            this.mytodo[i].fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
          }
          if (this.mytodo[i].mako == 'Yes') {
            this.mytodo[i].mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
          }
          if (this.mytodo[i].todoTypeName) {
            this.mytodo[i].todoType = this.mytodo[i].todoTypeName
            if (this.mytodo[i].todoType.includes("Custom To-Do")) {
              this.mytodo[i].todoType = 'Custom To-Do'
            }
          }
          // if (this.mytodo[i].pswIsActive) {
          //   this.mytodo[i].patientStatus = "Deactivate"
          // }
          this.mytodo[i].ID = i
        }
        if (this.mytodo[0].error) {
          this.toast.error(data[0].error, '', {
            timeOut: this.timealert
          });
        }
        this.dataSource = new ArrayStore({
          key: "ID",
          data: this.mytodo
        });

      }
    );
    this.filterValue = [];
    if (localStorage.getItem("completedFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("completedFilter")));
    }

  }

  getiddata(track, userAccountId, CN_id) {
    this.userService
      .getiddata(track, userAccountId, CN_id)
      .subscribe(
        data => {
          this.mytodo = data;

          this.temp_var = true;
          this.showloder = false;
          for (var i = 0; i < this.mytodo.length; i++) {
            if (this.mytodo[i].payorType == 2 && this.mytodo[i].bpci && this.mytodo[i].cjr != 'Y') {
              this.mytodo[i].group = 'BPCI-A' + '-' + this.mytodo[i].bpci;
            }
            else if (this.mytodo[i].cjr == 'Y' && this.mytodo[i].payorType == 2) {
              this.mytodo[i].group = 'CJR';
            } else if (this.mytodo[i].payorType == 1 && this.CurrentUser?.item?.commercialType && this.mytodo[i].cjr == 'N') {
              this.mytodo[i].group = 'Commercial';
            }
            else {
              this.mytodo[i].group = '';
            }
            if (this.mytodo[i].fracture == 'Y') {
              this.mytodo[i].fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
            }
            if (this.mytodo[i].mako == 'Yes') {
              this.mytodo[i].mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
            }
            if (this.mytodo[i].todoTypeName) {
              this.mytodo[i].todoType = this.mytodo[i].todoTypeName
              if (this.mytodo[i].todoType.includes("Custom To-Do")) {
                this.mytodo[i].todoType = 'Custom To-Do'
              }
            }
            this.mytodo[i].ID = i
          }
          this.dataSource = new ArrayStore({
            key: "ID",
            data: this.mytodo
          });
        }
      );
  }
  generatecompleted() {
    this.dataGrid.instance.deselectAll();
    window.localStorage['completed'] = 1;
    this.change = false;
    this.hidecompleted = false
    this.Name = `${this.gcpName} ${this.userService.translateText('hospital_portal.mytodos.completed.label')}`;
    this.temp_var = false;
    this.mytodo = [];
    this.dataSource = new ArrayStore()
    this.makeFilterFalse();
    this.gcpCompletedFilter = true;
    this.getiddata(this.generate, this.CurrentUser.item.userAccountId, this.patientservice.CN_id)
    this.filterValue = [];
    if (localStorage.getItem("gcpCompletedFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("gcpCompletedFilter")));
    }
  }
  trackcompleted() {
    this.dataGrid.instance.deselectAll();
    window.localStorage['completed'] = 1;
    this.change = false;
    this.hidecompleted = false
    this.Name = `${this.thdName} ${this.userService.translateText('hospital_portal.mytodos.completed.label')}`;
    this.temp_var = false;
    this.mytodo = [];
    this.dataSource = new ArrayStore()
    this.makeFilterFalse();
    this.thdCompletedFilted = true;
    this.getiddata(this.track, this.CurrentUser.item.userAccountId, this.patientservice.CN_id);
    this.filterValue = [];
    if (localStorage.getItem("thdCompletedFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("thdCompletedFilter")));
    }
  }
  followcompleted() {
    this.dataGrid.instance.deselectAll();
    window.localStorage['completed'] = 1;
    this.change = false;
    this.hidecompleted = false
    this.Name = `${this.followName} ${this.userService.translateText('hospital_portal.mytodos.completed.label')}`;
    this.temp_var = false;
    this.mytodo = [];
    this.dataSource = new ArrayStore()
    this.makeFilterFalse();
    this.followUpCompletedFitler = true;
    this.getiddata(this.follow, this.CurrentUser.item.userAccountId, this.patientservice.CN_id);
    this.filterValue = [];
    if (localStorage.getItem("followUpCompletedFitler")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("followUpCompletedFitler")));
    }

  }

  viewcompleted() {
    this.dataGrid.instance.deselectAll();
    window.localStorage['completed'] = 1;
    this.change = false;
    this.hidecompleted = false
    this.Name = `${this.symtomName} ${this.userService.translateText('hospital_portal.mytodos.completed.label')}`;
    this.temp_var = false;
    this.mytodo = [];
    this.dataSource = new ArrayStore()
    this.makeFilterFalse();
    this.vnsCompletedFilter = true;
    this.getiddata(this.symtom, this.CurrentUser.item.userAccountId, this.patientservice.CN_id);
    this.filterValue = [];
    if (localStorage.getItem("vnsCompletedFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("vnsCompletedFilter")));
    }

  }

  alltodo() {
    // alert("AlltoDo")
    window.localStorage['completed'] = 0;
    window.localStorage['setBugetFilter'] = 0;
    this.change = true;
    this.Name = this.userService.translateText('hospital_portal.mytodos.alltodos.label');
    this.hidecompleted = true
    this.temp_var = false;
    this.makeFilterFalse();
    this.alltodoFilter = true;
    this.filterValue = [];
    // this.clearFilter(event);
    this.mytodo = [];
    this.dataSource = new ArrayStore()
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';

    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": startdate,
      "endDateRange": enddate,
      "pracOrHsp": '',
      "todoViewMode": '',
      "loginHspOrPracId": '',
      "todoCategoryId": '',
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }
    this.patientservice.todolistbyrange(obj).subscribe(
      data => {
        this.temp_var = true;
        this.mytodo = data;
        this.showloder = false;
        for (var i = 0; i < this.mytodo.length; i++) {
          if (this.mytodo[i].payorType == 2 && this.mytodo[i].bpci && this.mytodo[i].cjr != 'Y') {
            this.mytodo[i].group = 'BPCI-A' + '-' + this.mytodo[i].bpci;
          }
          else if (this.mytodo[i].cjr == 'Y' && this.mytodo[i].payorType == 2) {
            this.mytodo[i].group = 'CJR';
          } else if (this.mytodo[i].payorType == 1 && this.CurrentUser?.item?.commercialType && this.mytodo[i].cjr == 'N') {
            this.mytodo[i].group = 'Commercial';
          }
          else {
            this.mytodo[i].group = '';
          }
          if (this.mytodo[i].fracture == 'Y') {
            this.mytodo[i].fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
          }
          if (this.mytodo[i].mako == 'Yes') {
            this.mytodo[i].mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
          }
          if (this.mytodo[i].todoTypeName) {
            this.mytodo[i].todoType = this.mytodo[i].todoTypeName
            if (this.mytodo[i].todoType.includes("Custom To-Do")) {
              this.mytodo[i].todoType = 'Custom To-Do'
            }
          }
          // if (this.mytodo[i].pswIsActive) {
          //   this.mytodo[i].patientStatus = "Deactivate"
          // }
          this.mytodo[i].ID = i
        }
        if (this.mytodo[0].error) {
          this.toast.error(data[0].error, '', {
            timeOut: this.timealert
          });
        }
        // ////console.log("My ToDo3", this.mytodo);

        // ////console.log("UserAccountId", this.CurrentUser.item.userAccountId)
        // if(this.patientservice.userFilter){
        // this.mytodo = this.mytodo.filter(i =>
        //   i.createdBy==parseInt(this.CurrentUser.item.userAccountId));
        // }
        this.patientservice.myTodoCount = this.mytodo.length;
        ////console.log("Filter AllTodo", this.mytodo)
        this.dataSource = new ArrayStore({
          key: "ID",
          data: this.mytodo
        });

        if (localStorage.getItem("alltodoFilter")) {
          this.filterValue = JSON.parse(atob(localStorage.getItem("alltodoFilter")));
        }


      }
    );

  }

  goToDashboard(id) {
    let self = this;
    let tempvar = { patSWFId: id }
    this.userService.setTempVar(tempvar)
    self.router.navigate([`/care/patientsummary`])
  }

  startTour() {
    this.tourService.initialize([{
      anchorId: 'start',
      content: 'Document for planning for optimal hospital discharge date (LOS), post-surgical discharge location and LOS, using a risk assessment and predictive algorithms When: Either after a patient completes their Home and Health Assessments or have not within 3 weeks of surgery ',
      title: 'Generate Care Plan',
      placement: 'right-top',

    }, {
      anchorId: 'start1',
      content: 'Mechanism for tracking actual hospital discharge date, discharge disposition, and post-surgical facility name When:Patients appear one day prior to planned hospital discharge (default to 2 days after day of surgery, unless changed by you)',
      title: 'Track Hospital Discharge'

    }, {
      anchorId: 'start2',
      content: 'Alert to contact the SNF facility for tracking discharge date (LOS) When: Displays starting 5 days after actual hospital discharge date, and continues every 5 days until actual SNF discharge date is documented',
      title: 'Follow up with PSC'

    }, {
      anchorId: 'start3',
      content: 'Review patients who have reported adverse symptom(s) via check-in and check-up assessments after surgery to help you manage by exception and follow-up When: 1, 2, 3, 4, 6, 8, 10, 12 days after surgery',
      title: 'View New Symptoms'

    }], {
      route: '/care/mytodo'
    });
    this.tourService.start();
  }

  End() {
    if (this.user.item.DeidFlag)
      this.userService.updatetour(this.user.item.userAccountId)
        .subscribe(
          data => {
            this.temp_var = true;
          }
        );

    this.tourService.end();
  }
  /*  datatableConfig(){
     $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
       const hospital:string = data[3].toString() || '';
       if(this.Name !=''){
         hospital.trim();
         if(hospital.toLowerCase().includes(this.Name))
         return true
       }
       if(this.Name == ''){
         return true;
       }
       return false;
     });
   }
   findBySerach():void{
     this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
       dtInstance.draw();
     });
   } */
  total(da) {
    ////console.log(da)
    let id: any;
    let surg: any;
    let prod: any;
    if (da.hosp) {
      let ab: any = new Array<any>();
      da.hosp.forEach(element => {
        // console.log(element)
        ab.push(element.hospitalId);
      });
      ////console.log(ab.toString())
      id = ab.toString();
      ////console.log(id)
    }
    else {
      id = null;
    }
    if (da.surgeon) {
      let ab: any = new Array<any>();
      da.surgeon.forEach(element => {
        ab.push(element.UserAccountId);
      });
      ////console.log(ab.toString())
      surg = ab.toString();
      ////console.log(surg)
    }
    else {
      surg = null;
    }
    if (da.proty) {
      prod = (da.proty.map(item => item.ServicelineLabel)).toString();
    }
    else {
      prod = null;
    }
    this.surg = surg
    this.hosp = id
    this.prod = prod
    this.savedownload(id)
  }

  savedownload(id) {
    let sentarray = {
      "bpcia": this.downloaddata.bpci,
      "clientId": this.CurrentUser.item.userAccountKey,
      "completed": false,
      "completedDate": null,
      "dashboardTransactionId": null,
      "dosFrom": this.downloaddata.from,
      "dosTo": this.downloaddata.to,
      "filePath": null,
      "hospitalPracticeId": id,
      "hspSugId": this.surg,
      "procedureType": this.prod,
      "pacEventName": this.downloaddata.pacEventName,
      "requestedBy": this.CurrentUser.item.userAccountId,
      "requestedDate": null
    }
    this.patientservice.savedownload(sentarray).subscribe(data => {
      if (data.Status.toLowerCase() == 'success') {
        this.toast.success(data.Message + this.userService.translateText('hospital_portal.disp_messages.req_processed_completed.success'), '', {
          timeOut: 5000
        })
        this.userService.logAudit('saveDashboardTransaction', 0).subscribe(data => { })
        this.downloaddata = {
          pacEventName: ''
        }
        this.hosp = null
        this.surg = null
        this.prod = null
        this.pacEventName = null
        this.tempvar = false
        this.caredownload()
        //this.modalRef.hide()
      }
      else if (data.Status.toLowerCase() == "failure") {
        this.toast.error(data.Message, '', {
          timeOut: this.timealert
        })
      }
    });
  }

  resetdownload() {
    this.downloaddata = {
      pacEventName: ''
    }
    this.hosp = ""
    this.surg = ""
    this.prod = ""
    this.req()
    this.downloadcare = false;
    this.popout = false;
    this.modalRef.hide();
  }

  downloadcareinfo(trac) {
    ////console.log("prod",trac.ProcedureType)
    this.downloadcare = true
    let hospital = '';
    let hosp: any = new Array<any>();
    if (trac.HospitalPracticeId) {

      let hosp_id = trac.HospitalPracticeId.split(',')
      for (var l = 0; l < hosp_id.length; l++) {
        for (var m = 0; m < this.dropdownList.length; m++) {
          if (hosp_id[l] == this.dropdownList[m].HospitalPracticeId) {
            if (hosp_id[0])
              hosp.push(this.dropdownList[m].HospitalName)

          }
        }
      }
      ////console.log("hosp",hosp)
      hospital = hosp
    }
    else {
      hospital = ''
    }
    let surgeon = '';
    let surg: any = new Array<any>();
    if (trac.Hsp_Sug_Id) {
      let sur_id = trac.Hsp_Sug_Id.split(',')
      for (var j = 0; j < sur_id.length; j++) {
        for (var i = 0; i < this.suglist.length; i++) {
          if (sur_id[j] == this.suglist[i].UserAccountId) {
            surg.push(this.suglist[i].SurgeonName)
          }
        }
      }
      ////console.log("sur",surg)
      surgeon = surg
      // surgeon = surg.toString()
      /*  var spl = surgeon.split(",");
       ////console.log("sur",surgeon,spl) */

    }
    else {
      surgeon = ''
    }

    if (trac.ProcedureType) {
      var proc = trac.ProcedureType.split(",")
      ////console.log("proc",proc)
    }

    this.down_care = {
      'RequestedDate': trac.RequestedDate,
      'DosFrom': trac.DosFrom,
      'DosTo': trac.DosTo,
      // 'surgeon': surgeon.toString(),
      'surgeon': surgeon,
      'ProcedureType': proc,
      'hospital': hospital,
      'bpci': trac.BPCIA

    }
    ////console.log("dc",this.down_care)
  }
  back() {
    this.downloadcare = false
    this.down_care = {}
  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }

  //Maintain filter data
  FilterVal() {
    if (this.dataGrid.filterValue)
      this.filterValue = this.dataGrid.filterValue;
    else
      this.filterValue = []
    if (this.alltodoFilter && this.filterValue.length != 0) {
      localStorage.setItem("alltodoFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.completedTodoFilter && this.filterValue != null) {
      localStorage.setItem("completedFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.gcpTodoFilter && this.filterValue != null) {
      localStorage.setItem("gcpFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.gcpCompletedFilter && this.filterValue.length != null) {
      localStorage.setItem("gcpCompletedFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.thdFilter && this.filterValue != null) {
      localStorage.setItem("thdFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.thdCompletedFilted && this.filterValue.length != null) {
      localStorage.setItem("thdCompletedFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.followUpFilter && this.filterValue.length != null) {
      localStorage.setItem("followupFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.followUpCompletedFitler && this.filterValue.length != null) {
      localStorage.setItem("followUpCompletedFitler", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.vnsFilter && this.filterValue.length != null) {
      localStorage.setItem("vnsFilter", btoa(JSON.stringify(this.filterValue)));
    }
    if (this.vnsCompletedFilter && this.filterValue.length != null) {
      localStorage.setItem("vnsCompletedFilter", btoa(JSON.stringify(this.filterValue)));
    }
    // alert(JSON.stringify(this.filterValue));

  }

  //Clear  Filter data
  clearFilter(event) {
    this.filterSurgeonId = ""
    this.filterhospitalId = ""
    this.clearFilterOption();
    this.maintainReassign = false;
    window.localStorage.removeItem('setBugetFilter');
    window.localStorage.removeItem('maintainCareList');
    window.localStorage.removeItem('maintainReassign');
    this.maintainReassign = false
    this.dynamicdropdown = false;
    this.selCare = '';
    //this.loadCareList();
    this.getReassignStaticTodoCN(this.CurrentUser.item.userAccountId, false);

    //if()



  }

  makeFilterFalse() {
    this.alltodoFilter = false;
    this.completedTodoFilter = false;
    this.gcpTodoFilter = false;
    this.gcpCompletedFilter = false;
    this.thdFilter = false;
    this.thdCompletedFilted = false;
    this.followUpFilter = false;
    this.vnsFilter = false;
    this.followUpCompletedFitler = false;
    this.vnsCompletedFilter = false;

  }

  clearFilterOption() {
    window.localStorage.removeItem('startdate');
    window.localStorage.removeItem('enddate');
    this.fliterdsate.startdate = '';
    this.fliterdsate.enddate = '';
    switch (true) {
      case this.alltodoFilter:
        window.localStorage.removeItem('alltodoFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.alltodo();
        break;
      case this.completedTodoFilter:
        window.localStorage.removeItem('completedFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.completed()
        break;
      case this.gcpTodoFilter:
        window.localStorage.removeItem('gcpFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.changeName()
        break;
      case this.gcpCompletedFilter:
        window.localStorage.removeItem('gcpCompletedFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.generatecompleted()
        break;
      case this.thdFilter:
        window.localStorage.removeItem('thdFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.changeName1()
        break;
      case this.thdCompletedFilted:
        window.localStorage.removeItem('thdCompletedFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.trackcompleted()
        break;
      case this.followUpFilter:
        window.localStorage.removeItem('followupFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.changeName2()
        break;
      case this.followUpCompletedFitler:
        window.localStorage.removeItem('followUpCompletedFitler')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.followcompleted()
        break;
      case this.vnsFilter:
        window.localStorage.removeItem('vnsFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.changeName3()
        break;
      case this.vnsCompletedFilter:
        window.localStorage.removeItem('vnsCompletedFilter')
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
        this.viewcompleted()
        break;

    }
  }

  newfun(e) {
    this.tooltipnew = e;
    this.phoneset = e.teleCode + ' - ' + e.phone
    if (this.tooltipnew.imagePath.search("default_") != -1)
      this.tooltipnew.deaultimg = true
    else
      this.tooltipnew.deaultimg = false
  }

  alllist(data) {
    let startdate
    let enddate
    if (data) {
      startdate = this.Datepipe.transform(this.changeFormatToDate(data.startdate), 'yyyy-MM-dd');
      enddate = this.Datepipe.transform(this.changeFormatToDate(data.enddate), 'yyyy-MM-dd');
    } else {
      this.ngOnInit();
    }
    window.localStorage['startdate'] = startdate
    window.localStorage['enddate'] = enddate

    const obj = {
      "loginUaId": this.CurrentUser.item.userAccountId,
      "selectedCnUaId": this.patientservice.CN_id,
      "patientSwfId": '',
      "startDateRange": startdate,
      "endDateRange": enddate,
      "pracOrHsp": '',
      "todoViewMode": '',
      "loginHspOrPracId": '',
      "todoCategoryId": '',
      'userGroupId': this.CurrentUser.item.userGroupId,
      'raHospitalIsOverlap': this.raHospitalIsOverlap,
      'raSurgeonIsOverlap': this.raSurgeonIsOverlap,
      "raSurgeonIds": this.filterSurgeonId ? this.filterSurgeonId : "",
      "raHospitalIds": this.filterhospitalId ? this.filterhospitalId : "",
    }
    this.patientservice
      .todolistbyrange(obj)
      .subscribe(
        data => {
          ////console.log(data)
          this.temp_var = true;
          this.mytodo = data;
          this.showloder = false;
          for (var i = 0; i < this.mytodo.length; i++) {
            //if (this.mytodo[i].payorType == 2 && this.mytodo[i].bpci && this.mytodo[i].cjr != 'Y' && this.CurrentUser.item.clientType == "BPCIA") {
            if (this.mytodo[i].payorType == 2 && this.mytodo[i].bpci && this.mytodo[i].cjr != 'Y' && this.CurrentUser.item.clientType.search("BPCIA") != -1) {
              this.mytodo[i].group = 'BPCI-A' + '-' + this.mytodo[i].bpci;
            }
            else if (this.mytodo[i].cjr == 'Y' && this.mytodo[i].payorType == 2) {
              this.mytodo[i].group = 'CJR';
            }
            else if (this.mytodo[i].payorType == 1 && this.CurrentUser?.item?.commercialType && this.mytodo[i].cjr == 'N') {
              this.mytodo[i].group = 'Commercial';
            }
            else {
              this.mytodo[i].group = '';
            }
            if (this.mytodo[i].fracture == 'Y') {
              this.mytodo[i].fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
            }
            if (this.mytodo[i].mako == 'Yes') {
              this.mytodo[i].mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
            }
            if (this.mytodo[i].todoTypeName) {
              this.mytodo[i].todoType = this.mytodo[i].todoTypeName
              if (this.mytodo[i].todoType.includes("Custom To-Do")) {
                this.mytodo[i].todoType = 'Custom To-Do'
              }
            }
            // if (this.mytodo[i].pswIsActive) {
            //   this.mytodo[i].patientStatus = "Deactivate"
            // }
            this.mytodo[i].ID = i
          }

          if (this.mytodo[0] && this.mytodo[0].error) {

            if (this.i == 0) {
              this.toast.error(data[0].error, '', {
                timeOut: this.timealert
              });
            }

          }
          this.dataSource = new ArrayStore({
            key: "ID",
            data: this.mytodo
          });
          this.patientservice.myTodoCount = this.mytodo.length;
        }
      );

  }

  Back() {
    this._location.back();
  }
  getdate(date) {
    if (this.CurrentUser.item)
      if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
        return this.Datepipe.transform(date, environment.dateForm);
      } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
        return this.Datepipe.transform(date, 'dd/MM/yyyy');
      }

  }
  getdatetime(date) {
    if (this.CurrentUser.item)
      if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
        return this.Datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
      } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
        return this.Datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
      }
  }
  getchange(data) {
    if (!data) {
      return 'none'
    }
  }
  getchange1(data) {
    if (data) {
      return 'none'
    }
  }
  getexcel(data) {
    if (!data) {
      return false
    } else {
      return true
    }
  }
  getexcel1(data) {
    if (data) {
      return false
    } else {
      return true
    }
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.CurrentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }



  // to-do config related
  gcpName: any;
  thdName: any;
  followName: any;
  symtomName: any;
  getTodoMapByClient(clientId) {
    this.patientservice
      .getTodoMapByClient(clientId, this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          if (data) {
            let index = _.findIndex(data, (o: any): any => {
              return o.seqNo == 1
            })
            if (index != -1) {
              this.generate = data[index].todoCategoryId
              this.gcpName = data[index].todoTitle
            }
            let index2 = _.findIndex(data, (o: any): any => {
              return o.seqNo == 2
            })
            if (index2 != -1) {
              this.track = data[index2].todoCategoryId
              this.thdName = data[index2].todoTitle
            }
            let index3 = _.findIndex(data, (o: any): any => {
              return o.seqNo == 3
            })
            if (index3 != -1) {
              this.follow = data[index].todoCategoryId
              this.followName = data[index3].todoTitle
            }
            let index4 = _.findIndex(data, (o: any): any => {
              return o.seqNo == 4
            })
            if (index4 != -1) {
              this.symtom = data[index2].todoCategoryId
              this.symtomName = data[index4].todoTitle
            }
          }
        })
  }

  //future todo
  futuretodo(filtersdate, name) {
    if (name == this.Name1 && filtersdate) {
      this.alllist(filtersdate)
    } else if (name == this.gcpName && filtersdate) {
      if (window.localStorage['setBugetFilter'] == 1) {
        if (window.localStorage['completed'] == 1) {
          this.generatecompleted()
        }
        else {
          this.changeName();
        }
      } else if (window.localStorage['setBugetFilter'] == 0) {
        if (window.localStorage['completed'] == 1) {
          this.completed()
        }
      }
    } else if (name == this.thdName && filtersdate) {
      if (window.localStorage['setBugetFilter'] == 2) {
        if (window.localStorage['completed'] == 1) {
          this.trackcompleted()
        }
        else {
          this.changeName1();
        }
      }
    } else if (name == this.followName && filtersdate) {
      if (window.localStorage['setBugetFilter'] == 3) {
        if (window.localStorage['completed'] == 1) {
          this.followcompleted()
        }
        else {
          this.changeName2();
        }
      }
    } else if (name == this.symtomName && filtersdate) {
      if (window.localStorage['setBugetFilter'] == 4) {
        if (window.localStorage['completed'] == 1) {
          this.viewcompleted()
        }
        else {
          this.changeName3();
        }
      }
    }
  }
  viewpatsummary(patswfid) {
    let tempvar = { patSWFId: patswfid }
    this.userService.setTempVar(tempvar)
    this.router.navigate([`/care/patientsummary`])
  }
  navigateonboard() {
    let self = this;
    self.patientservice.getPatientPassword(self.CurrentUser.item.userId, self.CurrentUser.item.userAccountId)
      .subscribe(data => {
        ////console.log(data)
        if (data.item.status == 'success') {
          var userEnc = encodeURIComponent(btoa(data.item.uname));
          var pasEnc = encodeURIComponent(data.item.pwd);
          window.location.href = environment.directobgin_url + '/#/oblogin/' + userEnc + "/" + pasEnc + "/";


        }
      })
  }


  selectRowId: any = [];
  deselectRowId: any = [];
  selectedItemKeys: any[] = [];
  multiple: string = 'multiple';
  select: boolean = false
  lengthcn: any;
  careList: any;
  selCare: any = '';
  reassign: any;
  public caremap: any = environment.practiceid;
  loadCareList() {
    this.userService.getCareList(this.CurrentUser.item.userAccountKey, this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          this.careList = data;
          this.lengthcn = this.careList.length
          if (this.CurrentUser.item.cnmappingct == 0 || this.CurrentUser.item.userAccountId == this.caremap) {
            this.selCare = 'ALL'
          } else {
            this.selCare = data.find(it => it.CNID == this.CurrentUser.item.userAccountId).CNID;
            this.CurrentUser.item.selectCNUserId = this.selCare;
          }
          this.selCare = ''
          ////console.log("select CN", this.selCare);

        }
      );
  }


  selectedData: any;
  selectedRowDataDX: any;
  selectedOverLab: boolean;
  selectionChanged(data: any, showassign) {
    data.selectedRowKeys = [];
    this.selectRowId = []; this.deselectRowId = []; this.selectedItemKeys = [];
    data.selectedRowsData.filter(obj => {
      if (obj.patientStatus != 'Deactivate')
        return this.selectRowId.push(obj.ID)
      else {
        return this.deselectRowId.push(obj.ID)
      }
    });
    data.selectedRowsData = data.selectedRowsData.filter(obj => obj.patientStatus != 'Deactivate');
    data.selectedRowKeys = this.selectRowId
    data.currentSelectedRowKeys = this.selectRowId
    data.currentDeselectedRowKeys = this.deselectRowId
    this.selectedItemKeys = data.selectedRowKeys;
    this.selectedRowDataDX = data.selectedRowsData;
    // console.log(" this.selectedRowDataDX", this.selectedRowDataDX);
    let todosurgeonId: string = "";
    let todohospitalId: string = "";
    if (this.selectedItemKeys.length >= 1) {
      if (this.CurrentUser.item.userGroupId == 9 || this.CurrentUser.item.userGroupId == 33) {
        this.selectedRowDataDX.forEach(element => {
          todosurgeonId = todosurgeonId ? todosurgeonId + ',' + element.surgeonId : element.surgeonId
        });
      }
      else if (this.CurrentUser.item.userGroupId == 17 || this.CurrentUser.item.userGroupId == 32) {
        this.selectedRowDataDX.forEach(element => {
          todohospitalId = todohospitalId ? todohospitalId + ',' + element.hospitalId : element.hospitalId
        });
      }
      const obj1 = {
        "loginClientId": this.CurrentUser.item.userAccountKey,
        "raTodoSurgeonIds": todosurgeonId,
        "raTodoHospitalIds": todohospitalId,
        "loginClientMode": this.CurrentUser.item.appRoles,
        "loginUserAccountId": this.CurrentUser.item.userAccountId
      }
      var _i;
      this.patientservice.postoverlaphspsurg(obj1).subscribe(data => {
        this.selectedOverLab = data.preRequisiteStatus;

        if (this.selectedOverLab && !this.maintainReassign) {

          if (this.CurrentUser.item.userGroupId == 9) {
            for (_i = 0; _i < this.selectedData.length; _i++) {
              this.selectedData[_i].todoRAOverlapMultiPracticeBeanList.forEach(element => {
                element.selected = false;
                if (element.reAssignSurgeonBeanList && element.reAssignSurgeonBeanList.length > 1)
                  element.reAssignSurgeonBeanList.forEach(it => {
                    it.selected = false;
                  });
              });
            }
          }
          else if (this.CurrentUser.item.userGroupId == 17) {
            for (_i = 0; _i < this.selectedData.length; _i++) {
              this.selectedData[_i].reAssignHospitalBeanList.forEach(element => {
                element.selected = false;
                if (element.todoRAHospitalMultiSOSBean && element.todoRAHospitalMultiSOSBean.length > 1)
                  element.todoRAHospitalMultiSOSBean.forEach(it => {
                    it.selected = false;
                  });
              });
            }
          }

          this.modalRef1 = this.modalService.show(showassign, {
            class: 'modal-md'
          })
        }
        else if (!this.selectedOverLab) {
          this.selectedhspUnderSurgeonId = '0';
          this.getReassignStaticTodoCN(this.CurrentUser.item.userAccountId, false)
        }

      })
    }
    // let deselectdata = data.selectedRowsData.filter(obj => obj.hospitalName != this.mytodo[data.currentSelectedRowKeys].hospitalName);
    // this.selectedOverLab &&



    if (this.selectedItemKeys.length > 0) {
      this.select = true

    } else {
      this.select = false
    }
  }


  getReassignStaticTodoCN(userAccountId, overLab) {
    //this.careList = [];
    if (this.CurrentUser.item.userGroupId == 9 || this.CurrentUser.item.userGroupId == 33) {
      this.getReassignTodoCNforSurgeon(userAccountId, this.raSurgeonIsOverlap, this.selectedhspUnderSurgeonId, 0)
    }
    else if (this.CurrentUser.item.userGroupId == 27 || this.CurrentUser.item.userGroupId == 17 || this.CurrentUser.item.userGroupId == 32) {
      this.getReassignTodoCNforHospital(userAccountId, this.raHospitalIsOverlap, 0)
    }
  }
  getReassignTodoCNforSurgeon(userAccountId, raHospitalIsOverlap, selectedhspUnderSurgeonId, selHosId) {
    this.patientservice.getReassignTodoCNforSurgeon(userAccountId, raHospitalIsOverlap, selectedhspUnderSurgeonId, selHosId).subscribe(
      data => {
        this.assignData(data, selHosId)
      }
    )
  }
  getReassignTodoCNforHospital(userAccountId, raHospitalIsOverlap, selHosId) {
    this.patientservice.getReassignTodoCNforHospital(userAccountId, raHospitalIsOverlap, selHosId).subscribe(
      data => {
        this.assignData(data, selHosId)
      }
    )
  }
  assignData(data, selHosId) {
    if (selHosId == 0) {
      this.careList = data;
    } else {
      this.careList1 = data;
      this.dynamicdropdown = true;
      localStorage.setItem('maintainCareList', JSON.stringify(this.careList1))
      this.dataGrid.instance.clearSelection()
      this.ngOnInit()
    }
  }
  selectRecords() {
    /* this.selectedItemKeys.forEach((key) => {
        this.dataSource.remove(key);
    }); */

    if (this.multiple == '') {
      this.multiple = 'multiple';
    }
    this.dataGrid.instance.refresh();
  }


  onCellPrepared(e) {
    if (e.rowType == "data" && e.column.command == 'select' && (e.data.patientStatus == 'Deactivate' || this.completedTodoFilter
      || this.gcpCompletedFilter || this.thdCompletedFilted || this.followUpCompletedFitler || this.vnsCompletedFilter)) {
      var editor = CheckBox.getInstance(e.cellElement.querySelector(".dx-select-checkbox"));
      editor.option("disabled", true);
      e.cellElement.style.pointerEvents = 'none';
    }
  }

  carenav(assign: TemplateRef<any>) {

    ////console.log(event,this.selCare)
    let patid = []
    this.selectedItemKeys.forEach((key) => {
      /* alert('Patient Id'+this.patient[key].ID+'--------'+'carnav id'+event ) */
      patid.push(this.mytodo[key].patientSwfId)
    });
    let stykeradmin = window.localStorage['superClientId']
    let pat = patid.toString()
    this.reassign = {
      assignedTo: this.selCare,
      assignedFrom: this.patientservice.CN_id,
      patSWFId: pat,
      userAccId: this.CurrentUser.item.userAccountId,
      userAccountKey: this.CurrentUser.item.userAccountKey,
      stykerAdmin: stykeradmin ? stykeradmin : 0
    }
    this.modalRef1 = this.modalService.show(assign, {
      class: 'modal-sm'
    })

    //this.getTodoConfigurationStatus(this.reassign.userAccId, this.reassign.assignedTo, showassign, todoConfig);


    this.movable()
  }
  getConfigtodo: any;
  getTodoConfigurationStatus(userAccId, assignedTo, showassign, todoConfig) {
    this.patientservice.getTodoConfigurationStatus(this.reassign)
      .subscribe(data => {
        this.getConfigtodo = data;

        if (this.getConfigtodo.Status == 'true') {
          this.modalRef1 = this.modalService.show(todoConfig, {
            class: 'modal-sm'
          })
        }
        else {
          this.modalRef1 = this.modalService.show(showassign, {
            class: 'modal-sm'
          })
        }
      })
  }

  yestoshow() {
    this.showloder = true
    if (this.selectedRowDataDX.length >= 1) {
      this.list_to_tree(this.selectedRowDataDX)
    }

    const reassignTodo = {
      "todoReAssignPatSwfBeanList": this.todoReAssignPatSwfBeanList,
      "todoReAssignedFromUaId": this.patientservice.CN_id,
      "todoReAssignedLoginUaId": this.CurrentUser.item.userAccountId,
      "todoReAssignedToUaId": this.selCare
    }
    this.selCare = ''
    this.patientservice.postTodoReassign(reassignTodo).subscribe(
      data => {
        if (data.status == "true") {

          this.toast.toastrConfig.timeOut = 3000;
          this.toast.success(this.userService.translateText('hospital_portal.disp_messages.reassigned.success'), '', {
            timeOut: this.timealert
          });
          this.ngOnInit();
          this.select = false;
          //this.multiple == ''
          this.multiple = 'multiple';
          this.dataGrid.instance.clearSelection();
        }

      }

    )
    this.modalRef1.hide()

  }


  todoReAssignPatSwfBeanList: any = [];
  list_to_tree(list) {
    var node = [], i;
    this.todoReAssignPatSwfBeanList = [];
    let rootLength = list.length;
    for (i = 0; i < rootLength; i += 1) {
      if (list.length > 0) {


        let takeInstialPatId = list[0].patientSwfId;
        let getDuplicatePatList = list.filter(item => {
          return item.patientSwfId == takeInstialPatId
        })
        this.todoReAssignPatSwfBeanList.push({
          'todoCategoryBeanList': [],
          'patientSwfId': takeInstialPatId
        })
        let v = 0
        if (getDuplicatePatList && getDuplicatePatList.length >= 1) {
          for (let j = 0; j < getDuplicatePatList.length; j++) {
            if (this.getTodoCategoryCheck(getDuplicatePatList[j].todoTypeId, getDuplicatePatList) || j == 0) {
              this.todoReAssignPatSwfBeanList[i].todoCategoryBeanList
                .push({ 'todoSubCategoryBeanList': [], 'todoCategoryId': getDuplicatePatList[j].todoTypeId })

              v = this.todoReAssignPatSwfBeanList[i].todoCategoryBeanList.length - 1
              let takeInstialId = getDuplicatePatList[j].todoTypeId;
              let getDuplicateList = getDuplicatePatList.filter(item => {
                return item.todoTypeId == takeInstialId
              })
              // console.log(getDuplicatePatList,"getDuplicatePatList")

              if (getDuplicateList && getDuplicateList.length >= 1) {
                let todoPkIdforpat = "";
                for (let k = 0; k < getDuplicateList.length; k++) {
                  if (this.todoReAssignPatSwfBeanList[i].todoCategoryBeanList[v]
                    && this.todoReAssignPatSwfBeanList[i].todoCategoryBeanList[v].todoSubCategoryBeanList) {
                    this.todoReAssignPatSwfBeanList[i].todoCategoryBeanList[v]
                      .todoSubCategoryBeanList.push({
                        'todoPkId': getDuplicateList[k].todoPkId,
                        'todoPkName': getDuplicateList[k].todoTypeName
                      })
                  }
                }
              }



              // console.log(removedItem,"removedItem" + '<br>' + list , "List")

              // rootLength = list.length;
            }

            // console.log(rootLength,"rootLength")
          }
        }
      }
    }
    // console.log(this.todoReAssignPatSwfBeanList,"todoReAssignPatSwfBeanList")

    console.log(JSON.stringify(this.todoReAssignPatSwfBeanList), "todoReAssignPatSwfBeanList")
  }
  getTodoCategoryCheck(todoTypeId, getDuplicatePatList) {
    getDuplicatePatList.sort();

    var current = null;
    var cnt = 0;
    for (var i = 0; i < getDuplicatePatList.length; i++) {
      if (getDuplicatePatList[i].todoTypeId != current) {
        if (current == todoTypeId && cnt > 1) {
          return false
        }
        current = getDuplicatePatList[i].todoTypeId;
        cnt = 1;
      } else {
        cnt++;
      }
    }
    if (current == todoTypeId && cnt > 1) {
      return false
    } else
      return true
  }
  getBPCIA() {
    if (this.CurrentUser.item.clientType && this.CurrentUser.item.clientType.search("BPCIA") != -1)
      return true
    else
      return false
  }
  getmytodolength() {


    if (window.localStorage['startdate'] && window.localStorage['enddate']) {
      this.patientservice.countrange(this.CurrentUser.item.userAccountId, window.localStorage['startdate'], window.localStorage['enddate'])
        .subscribe(
          data => {
            this.CurrentUser.item.mytodolength = data.todoCount
            this.CurrentUser.item.msgcount = data.messageCount;
          }
        );
    }
    else {
      this.patientservice.countrange(this.CurrentUser.item.userAccountId, 'N', 'N').subscribe(data => {
        this.CurrentUser.item.mytodolength = data.todoCount
        this.CurrentUser.item.msgcount = data.messageCount;
      })
    }
  }

  getDownloadData() {
    let data: any = {
      bpcia: this.downloaddata.bpci,
      hsp_Sug_Id: this.surg,
      procedureType: this.prod,
      dosFrom: this.Datepipe.transform(this.downloaddata.from, 'yyyy-MM-dd'),
      dosTo: this.Datepipe.transform(this.downloaddata.to, 'yyyy-MM-dd'),
      clientId: this.CurrentUser.item.userAccountKey,
      hospitalPracticeId: this.hosp,
      currentPacEvent: this.downloaddata.pacEventName,
      userAccountId: this.CurrentUser.item.userAccountId,
      lang: this.userService.selectedLang()
    }
    console.log(data,"data")
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    window.open(this.apiurl + this.download_care + data);
    this.resetdownload();
  }

  exportToExcel(event) {
    event.fileName = this.getTitle();
    this.dataGrid.instance.exportToExcel(false);
  }
}
